function funcionInit(){
    if (!"geolocation" in navigator) {
        return alert("Tu navegador no soporta el acceso a la ubicación. Intenta con otro");
    }

    const onUbicacionConcedida = ubicacion => {
        coordenadas = ubicacion.coords;
        latitud = coordenadas.latitude;
        longitud = coordenadas.longitude;

        $('#latitud').val(latitud);
        $('#longitud').val(longitud);
        //console.log(latitud+' '+longitud);
        $('#filtros-form').submit();
    }
      
    const onErrorDeUbicacion = err => {
        console.log("Error obteniendo ubicación: ", err);
    }

    const opcionesDeSolicitud = {
        enableHighAccuracy: true, // Alta precisión
        maximumAge: 0, // No queremos caché
        timeout: 15000 // Esperar solo 5 segundos
    };
        // Solicitar
    navigator.geolocation.getCurrentPosition(onUbicacionConcedida, onErrorDeUbicacion, opcionesDeSolicitud);
}

document.addEventListener("DOMContentLoaded", function(){
    //console.log(sessionStorage.getItem("g-denied"));
    var pathname = window.location;
    //console.log('ubase: '+ubase+' pathname: '+pathname);
    if(ubase+'/' == pathname){
        if ( navigator.permissions && navigator.permissions.query) {
            navigator.permissions.query({name:'geolocation'}).then(function(p) {
                //console.log(p.state);
                if(p.state == 'granted'){
                    $('#modal-geolocalizacion').modal('hide');
                    sessionStorage.removeItem("d-denied");

                }
                if(p.state == 'denied'){
                    $('#modal-geolocalizacion').modal('show');
                     sessionStorage.removeItem("g-denied");
                }
                if(sessionStorage.getItem("g-denied") == 'true'){
                    $('#modal-geolocalizacion').modal('hide');
                }else{
                    $('#modal-geolocalizacion').modal('show');
                }

                p.addEventListener('change', function() {
                  //console.log(p.state);
                });
            });
        }else{
            if(sessionStorage.getItem("g-denied") == 'true'){
                $('#modal-geolocalizacion').modal('hide');
            }else{
                $('#modal-geolocalizacion').modal('show');
            }
        }
    }

    $('#permitir-geolocalizacion').click(function(){
        //console.log('permitir-geolocalizacion');
        $('#modal-geolocalizacion').modal('hide');
        funcionInit();
    })

    $('#no_permitir-geolocalizacion').click(function(){
        $('#modal-geolocalizacion').modal('hide');
        if (window.sessionStorage) {
            sessionStorage.setItem("g-denied", "true");
        }
    })
});
